<template>
  <div class="room-bind-meter-archive-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('roomBindMeterArchive.title') }}</div>
        <div class="header-tools">
          <el-button type="primary" size="small" icon="el-icon-close" @click="_goBack">
            {{ $t('common.back') }}
          </el-button>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-form label-width="120px">
            <el-form-item :label="$t('roomBindMeterArchive.room')">
              <el-input v-model.trim="bindInfo.roomName" :placeholder="$t('roomBindMeterArchive.roomPlaceholder')"
                disabled />
            </el-form-item>

            <el-form-item :label="$t('roomBindMeterArchive.meterArchive')">
              <el-col :span="18">
                <el-input v-model.trim="bindInfo.meterArchiveName" :placeholder="$t('roomBindMeterArchive.meterArchivePlaceholder')"
                  disabled />
              </el-col>
              <el-col :span="4" :offset="1">
                <el-button type="primary" size="small" icon="el-icon-search" @click="_openChooseMeterArchive" >
                  {{ $t('roomBindMeterArchive.selectMeterArchive') }}
                </el-button>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('roomBindMeterArchive.meterAddr')">
              <el-input v-model.trim="bindInfo.meterAddr" disabled />
            </el-form-item>

            <el-form-item :label="$t('roomBindMeterArchive.meterType')">
              <el-input v-model.trim="bindInfo.meterTypeName" disabled />
            </el-form-item>

            <el-form-item :label="$t('roomBindMeterArchive.userName')">
              <el-input v-model.trim="bindInfo.userName" disabled />
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
    </el-card>

    <el-row>
      <el-col :span="24" class="text-right" style="margin-top: 20px;">
        <el-button type="primary" icon="el-icon-check" @click="saveBindInfo" >
          {{ $t('common.submit') }}
        </el-button>
      </el-col>
    </el-row>

    <search-meter-archive ref="searchMeterArchiveRef" @chooseMeterArchive="handleChooseMeterArchive" />
  </div>
</template>

<script>
import { queryRooms } from '@/api/owner/roomBindOwnerApi'
import { queryMeterUserArchives, bindRoomMeterArchive } from '@/api/room/meterArchiveApi'
import { getCommunityId } from '@/api/community/communityApi'
import searchMeterArchive from '@/components/room/searchMeterArchive'
import { getDateYYYYMMDD } from '@/utils/dateUtil'

export default {
  name: 'RoomBindMeterArchive',
  components: {
    searchMeterArchive
  },
  data() {
    return {
      bindInfo: {
        roomId: '',
        roomName: '',
        archiveId: '',
        meterArchiveName: '',
        meterAddr: '',
        meterType: '',
        meterTypeName: '',
        userName: '',
        startTime: '',
        endTime: '2099-01-01',
        remarks: '',
        communityId: ''
      },
      communityId: '',
      ifBind: false
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.bindInfo.startTime = getDateYYYYMMDD()
    this.bindInfo.communityId = this.communityId
    this.initData()
  },
  methods: {
    initData() {
      const roomId = this.$route.query.roomId
      if (roomId) {
        this.bindInfo.roomId = roomId
        this.listRoom(roomId)

      }
    },
    async listRoom(roomId) {
      try {
        const params = {
          page: 1,
          row: 1,
          roomId: roomId,
          communityId: this.communityId
        }
        const res = await queryRooms(params)
        const room = res.rooms[0]
        this.bindInfo.roomName = `${room.floorNum}-${room.unitNum}-${room.roomNum}`


        const params1 = {
          page: 1,
          row: 1,
          communityId: this.communityId,
          roomId: roomId,
        }

        const res1 = await queryMeterUserArchives(params1)
        if(res1.data != null && res1.data.length > 0){
            const meterArchive = res1.data[0]
            this.bindInfo.archiveId = meterArchive.archiveId
            this.bindInfo.meterArchiveName = `${meterArchive.userName} - ${meterArchive.meterAddr}`
            this.bindInfo.meterAddr = meterArchive.meterAddr
            this.bindInfo.meterType = meterArchive.meterType
            this.bindInfo.meterTypeName = this.getMeterTypeName(meterArchive.funType)
            this.bindInfo.userName = meterArchive.userName
            if(this.bindInfo.archiveId != ''){
                this.ifBind = true
            }
            console.log('Component created:', this.ifBind);
        }

      } catch (error) {
        this.$message.error(this.$t('roomBindMeterArchive.fetchRoomError'))
      }
    },
    handleChooseMeterArchive(meterArchive) {
      this.bindInfo.archiveId = meterArchive.archiveId
      this.bindInfo.meterArchiveName = `${meterArchive.userName} - ${meterArchive.meterAddr}`
      this.bindInfo.meterAddr = meterArchive.meterAddr
      this.bindInfo.meterType = meterArchive.meterType
      this.bindInfo.meterTypeName = this.getMeterTypeName(meterArchive.funType)
      this.bindInfo.userName = meterArchive.userName
    },
    getMeterTypeName(funType) {
      const typeMap = {
        1: this.$t('roomBindMeterArchive.waterMeter'),
        2: this.$t('roomBindMeterArchive.electricMeter'),
        3: this.$t('roomBindMeterArchive.gasMeter')
      }
      return typeMap[funType] || this.$t('roomBindMeterArchive.otherMeter')
    },
    _openChooseMeterArchive() {
      this.$refs.searchMeterArchiveRef.open(this.communityId)
    },
    _goBack() {
      this.$router.go(-1)
    },
    bindValidate() {
      const rules = {
        archiveId: { required: true, message: this.$t('roomBindMeterArchive.meterArchiveRequired') },
        roomId: { required: true, message: this.$t('roomBindMeterArchive.roomRequired') },
        startTime: { required: true, message: this.$t('roomBindMeterArchive.startTimeRequired') },
        endTime: { required: true, message: this.$t('roomBindMeterArchive.endTimeRequired') }
      }

      const errors = []
      Object.keys(rules).forEach(key => {
        if (!this.bindInfo[key]) {
          errors.push(rules[key].message)
        }
      })

      if (errors.length > 0) {
        this.$message.error(errors[0])
        return false
      }

      const start = new Date(this.bindInfo.startTime)
      const end = new Date(this.bindInfo.endTime)
      if (start >= end) {
        this.$message.error(this.$t('roomBindMeterArchive.timeError'))
        return false
      }

      return true
    },
    async saveBindInfo() {
      if (!this.bindValidate()) return

      try {
        const data = {
          ...this.bindInfo,
          communityId: this.communityId
        }

        const res = await bindRoomMeterArchive(data)

        if (res.data.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this._goBack()
        } else {
          this.$message.error(res.msg || this.$t('common.submitFailed'))
        }
      } catch (error) {
        this.$message.error(this.$t('common.requestError'))
      }
    }
  }
}
</script>

<style scoped>
.room-bind-meter-archive-container {
  padding: 20px;
}

.header-tools {

}

.text-right {
  text-align: right;
}

.addStartTime,
.addEndTime {
  width: 100%;
}
</style>